export default __webpack_public_path__ + "static/media/other_background.57d9e324.jpg";